import InfoSection from "../../components/contact/InfoSection";
import Hero from "../../components/contact/Hero";

const Contact = () => {
  return (
    <>
      <Hero />
      <InfoSection />
    </>
  );
};

export default Contact;
